import { render, staticRenderFns } from "./School.vue?vue&type=template&id=0c8aeb14&scoped=true&lang=pug&"
import script from "./School.vue?vue&type=script&lang=ts&"
export * from "./School.vue?vue&type=script&lang=ts&"
import style0 from "./School.vue?vue&type=style&index=0&id=0c8aeb14&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8aeb14",
  null
  
)

export default component.exports